import { Injectable } from '@angular/core';
import { BillingInvoice } from '../../../model/billing/billing-invoice';
import { ClientFilter } from '../../../model/client-filter';
import { InvoiceNumberBookPoint } from '../../../model/invoice-number-book-point';
import { BillingInvoiceEditInfo } from '../../../model/billing/billing-invoice-edit-info';
import { BillingInvoiceCreateResponse } from '../../../model/billing/billing-invoice-create-response';
import { ReportViewer } from '../../../model/report-viewer';
import { BillingInvoiceItemEditInfo } from '../../../model/billing/billing-invoice-item-edit-info';
import { BillingInvoiceEntityService } from './billing-invoice-entity.service';
import { BillingInvoiceCreditEntityService } from './billing-invoice-credit-entity.service';
import { AliquotTaxService } from '../../aliquot-tax/aliquot-tax.service';
import { BillingInvoiceManualService } from '../billing-invoice-manual/billing-invoice-manual.service';
import { ClientSearch } from '../../../model/client-search';
import { BillingInvoiceAmountService } from '../billing-invoice-amount.service';
import { BillingInvoiceManualCreditService } from '../billing-invoice-manual/billing-invoice-manual-credit.service';
import { BillingInvoiceCreditAmountService } from '../billing-invoice-credit-amount.service';

@Injectable({
  providedIn: 'root'
})
export abstract class BillingInvoiceEditService {

  constructor ( public billingInvoiceEntityService: BillingInvoiceEntityService,
                public aliquotTaxService: AliquotTaxService,
                public billingInvoiceManualCreditService: BillingInvoiceManualCreditService,
                public billingInvoiceAmountService: BillingInvoiceAmountService,
                public billingInvoiceCreditAmountService: BillingInvoiceCreditAmountService,
                public billingInvoiceManualService: BillingInvoiceManualService,
                public billingInvoiceCreditEntityService: BillingInvoiceCreditEntityService ) { }

  abstract isVisibleIsRejectedOptions(): boolean;

  abstract isVisibleBillingInvoiceItemManual(): boolean;

  abstract isVisibleBillingInvoiceItemEntity(): boolean;

  abstract noDeleteItemManual(): boolean;

  abstract isVisibleDatesFromTo(): boolean;

  abstract isVisibleBillingInvoiceAssociate(): boolean;

  abstract isVisibleCirculacionAbierta(): boolean;

  abstract isVisibleBillingInvoiceItemEntityCredit(): boolean;

  abstract setBillingInvoiceManualParams(sectorId: number,
    invoiceTypeId: number );

  abstract setBillingInvoiceParams(sectorId: number,
    preBillingId: number, invoiceTypeId: number );

  abstract setBillingInvoiceCreditParams(sectorId: number, billingInvoiceId: number );

  abstract billingInvoiceCreate(clientFilter: ClientSearch,
          invoiceNumberBookPoint: InvoiceNumberBookPoint, billingInvoice: BillingInvoice,
          medicalAppointmentProcedureExcludeIds: number[],
          items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoiceCreateResponse>;

  abstract getParentInvoiceCompleteNumber(): string;

  abstract getInvoiceTypeId(): number;
 
  abstract getBillingInvoiceEditInfo(): Promise<BillingInvoiceEditInfo>;

  abstract getBillingInvoiceReport( billingInvoiceId: number  ): Promise<ReportViewer>;

  abstract getBillingInvoiceItemEditInfos(): Promise<BillingInvoiceItemEditInfo[]>;

  abstract calculateBillingInvoice(billingInvoice: BillingInvoice, items:   BillingInvoiceItemEditInfo[]): Promise<BillingInvoice>;
}